<template>
    <search-summary-layout
        :search-disabled="searchDisabled"
        :search-request="searchRequest"
        :form-component="searchFormComponent"
        show-tourists
    >
        <template v-slot:title>
            <v-row>
                <v-col
                    v-for="location in locationLabel"
                    :key="location"
                    cols="12"
                    class="text-body-2 white-space-normal"
                >
                    {{ location }}
                </v-col>
            </v-row>
        </template>
    </search-summary-layout>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator'
    import SearchSummaryLayout from '~src/components/parts/searchSummaryLayout.src'
    import {searchRequest} from '~src/utils/flights/flights-blank-states.src'
    import FlightSearchForm from '~src/components/flights/search/forms/flightSearchForm.src'

    //TODO Hide if empty searchRequest
    @Component({
        components: {
            SearchSummaryLayout,
            FlightSearchForm,
        },
    })
    export class FlightSearchSummary extends Vue {
        @Prop({default: false, type: Boolean}) searchDisabled
        @Prop({default: () => searchRequest()}) searchRequest
        @Prop({default: false, type: Boolean}) searchActive

        searchForm = false

        get searchFormComponent() {
            return resolveComponent('FlightSearchForm')
        }

        get locale() {
            return this.$i18n.locale
        }

        get locationLabel() {
            return flightsRuntimeStore.routes.map(({departure, arrival, date}) => {
                return `${this.$filters.dateFormat(date)} | ${departure.cityName}, ${departure.countryName} (${
                    departure.iataCode
                }) - ${arrival.cityName}, ${arrival.countryName} (${arrival.iataCode})`
            })
        }

        get date() {
            return this.searchRequest.dateTime
        }

        @Watch('searchActive')
        onLoadingChange(searchActive) {
            if (searchActive) {
                this.searchForm = false
            }
        }

        checkDisabled(on) {
            if (this.searchDisabled) return
            return on
        }
    }

    export default FlightSearchSummary
</script>

<style scoped lang="scss">
    .white-space-normal {
        white-space: normal;
    }
</style>
